import type { ConnectorDTO } from "../../../shared/types";
import { TextLink } from "../../components/TextLink";
import { Panel } from "../../components/ui";
import { CopyBox } from "./ConnectorWays";

/**
 * An internal tool's Setup (2026-10-23): no key and no login to manage — AgentOS vouches for each call with a signed pass.
 * The audience its passes are made for (its own address's origin, which follows the base URL) and where the tool reads
 * AgentOS's public keys. Who has it is the Access tab.
 */
export function InternalPass({ connector, onShowAccess }: { connector: ConnectorDTO; onShowAccess: () => void }) {
  const name = connector.name;
  return (
    <Panel title="Connected through Pandas" hint={`People and agents with ${name} need no key and no login: each call carries a pass AgentOS signs, good for five minutes.`}>
      <div className="space-y-4">
        <p className="text-sm">
          On for everyone by default; switch someone off in <TextLink to="/admin/users">Users</TextLink>.
        </p>
        <CopyBox label="Audience" value={connector.audience ?? new URL(connector.baseUrl).origin} />
        <CopyBox label="AgentOS's public keys (JWKS)" value={`${location.origin}/.well-known/jwks.json`} />
        <p className="text-xs text-muted">
          {name} accepts only passes made for its own address, checked against these keys. A pass names the person the run works for by their email, or the agent working on its own. An agent reaches {name} with the switch on its own page:{" "}
          <TextLink onClick={onShowAccess}>see who has it</TextLink>.
        </p>
      </div>
    </Panel>
  );
}
